module.exports = __webpack_public_path__ + "static/img/icon_wechatmini_faq.e3cc95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_wechatmini_faq.png
// module id = 4iwH
// module chunks = 1 5